export const recover = {
  step1: {
    label: 'Paso 1',
    title: 'Envío de código',
    body: 'Ingresa tu dirección de E-mail. Te enviaremos un código con el que podrás crear una nueva contraseña.',
    labelEmail: 'E-mail',
    sendCode: 'Enviar código',
  },
  step2: {
    label: 'Paso 2',
    title: 'Nueva contraseña',
    body: 'Ingresa el código enviado a tu dirección de E-mail y la nueva contraseña que desees.',
    labelEmail: 'E-mail',
    labelCode: 'Código',
    labelNewPassword: 'Nueva contraseña',
    accept: 'Aceptar',
  },
}



// WEBPACK FOOTER //
// ./src/sections/recover/text.js